import React from 'react';
import PropTypes from 'prop-types';

/**
 * ModalCardHeader - A wrapper that renders a standard HTML header with Bulma class names
 * 
 * This component accepts the same props as Bloomer ModalCardHeader for easy migration
 */
const ModalCardHeader = ({
  className = '',
  children = null,
  style = {},
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['modal-card-head'];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <header
      className={getClassNames()}
      style={style}
      {...props}
    >
      {children}
    </header>
  );
};

// eslint-disable-next-line react/require-default-props
ModalCardHeader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};



export default ModalCardHeader;
